// extracted by mini-css-extract-plugin
module.exports = {"container":"container___3VfkZ","box":"box___2KW_y"};